import { post } from '@rails/request.js';

async function parseJson(response) {
  try {
    return await response.json;
  } catch {
    return null;
  }
}

async function phoneVerificationPost(path, body) {
  const response = await post(path, { body, responseKind: 'json' });
  const json = await parseJson(response);

  return { response, payload: json?.data ?? null, error: json?.error ?? null };
}

export function startPhoneVerification({ phone } = {}) {
  return phoneVerificationPost('/phone/verify/start', phone ? { phone } : {});
}

export function checkPhoneVerification({ code }) {
  return phoneVerificationPost('/phone/verify/check', { code });
}

export function continueAfterPhoneMerge() {
  return phoneVerificationPost('/phone/verify/continue', {});
}

export function skipPhoneVerification() {
  return phoneVerificationPost('/phone/verify/skip', {});
}
